module.exports = __webpack_public_path__ + "static/media/down-arrow-orange.db27a399.svg";